import { RemoveUser, User, UserPayload } from "models";
import axiosClient from "./axiosClient";

const userApi = {
  getUsersList(data: UserPayload): Promise<User> {
    const url = `/users/getChildUsers?limit=${data.limit || ""}&page=${
      data.page || ""
    }&search=${data.search || ""}&sortName=${data.sortName || ""}&sortType=${
      data.sortType || ""
    }&brandId=${data.brandId || ""}&storeId=${data.storeId || ""}`;
    return axiosClient.get(url);
  },

  updateUser(data: UserPayload): Promise<User> {
    const url = `/users/addUpdateChildUser`;
    return axiosClient.post(url, data);
  },

  deleteUser(data: RemoveUser): Promise<User> {
    const url = `/users/removeChildUser?id=${data?._id}`;
    return axiosClient.delete(url);
  },
};

export default userApi;
